import React, { useState, useEffect } from "react";
import "./AddFolder.scss";
import { motion } from "framer-motion";


import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  handleBottomDrawer,
  handleBottomDrawerAddFolder,
} from "../../actions/actionCreators";

import "react-tagsinput/react-tagsinput.css";
import {
  createFolder,
  getAllFolders,
} from "../../actions/folders-actions/actions";
import {
  clearAllAlerts,
  removeAlert,
  setAlert,
} from "../../actions/alerts-actions/actions";
// import { Select } from "antd";
import Select, { components } from "react-select";
import { v4 as uuidv4 } from "uuid";
import Alert from "../Alert/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolderPlus,
  faFolderOpen,
  faCaretDown,
} from "@fortawesome/free-solid-svg-icons";
import { getGenders } from "../../actions/left-menu-actions/actions";

import { AddOrderBottomDrawer } from "./AddOrderBottomDrawer";
import {
  createArticle,
  getCollaborators,
} from "../../actions/order-actions/actions";
import { addOrder } from "../../actions/order-actions/actions";
import { BrowserRouter, useParams, useLocation } from "react-router-dom";
import { AddArticleBottomDrawer } from "./AddArticleBottomDrawer";
import { history } from "../../index";
import Bag from "../../icons/Bag";

export interface IAddFolderProps {
  setMode: ((mode: string) => void) | undefined;
  withRoot: boolean;
  addFolder?: boolean;
  addArticle?: boolean;
  addOrderDrawer?: boolean;
}

export default function AddFolder({
  setMode,
  withRoot,
  addArticle,
  addOrderDrawer,
  addFolder,
}: IAddFolderProps) {
  const dispatch = useDispatch();
  const CaretDownIcon = () => {
    return <FontAwesomeIcon icon={faCaretDown} />;
  };

  const FolderIcon = () => {
    return <FontAwesomeIcon icon={faFolderOpen} />;
  };

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        {addArticle || addOrderDrawer ? <CaretDownIcon /> : <FolderIcon />}
      </components.DropdownIndicator>
    );
  };

  const [width, setWidth] = useState(window.innerWidth);
  const [fodlerSelected, setfodlerSelected] = useState<any>("");

  const [height, setHeight] = useState(window.innerHeight);
  const [allGenders, setAllGenders] = useState([]);
  const [folderData, setfolderData] = useState({
    name: "",
    description: "",
    collaborator: [],
    season:'',
    year:""
  });
  const [tags, setTags] = useState([]);
  const [data, setData] = useState<any>({
    name: "",
    details: "",
    collaborator: [],
    season:'',
    year:""
  });


  useEffect(() => {
    dispatch(getCollaborators(""));
  

}, []);
  const params: any = useParams();

  const location: any = useLocation();
  // GET COLLEAGUES


  const handleChangeOrder = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleChangeDeliveryDate = (e: any) => {
    setData({ ...data, delivery_date: e.target.value });
  };


  const handleType = (e: any) => {
    setData({ ...data, type: e.value });
  };
  const { collaborators, newOrder, orders, createOrderLoading } = useSelector(
    (state: any) => state.orders
  );
  const alerts = useSelector((state: any) => state.alerts);
  const folders = useSelector((state: any) => state.folders);
  const leftMenu = useSelector((state: any) => state.leftMenu);
  const [orderCreated, setOrderCreated] = useState<any>(null);


  useEffect(() => {
    if (addOrderDrawer) {
      dispatch(getCollaborators(""));
    }
    if (addArticle) {
      dispatch(getGenders());
    }
  }, []);

  useEffect(() => {
    if (leftMenu.allGenders.data) {
      setAllGenders(
        leftMenu.allGenders.data.map((el: any) => {
          return {
            label: el.name,
            value: el.id,
          };
        })
      );
    }
  }, [leftMenu.allGenders]);

  const handleCollabChange = (e: any) => {
    setData({
      ...data,
      collaborator: e && e.map((el: any) => el.value),
    });
  };

  // useEffect(() => {
  //   if (newOrder) {
  //     setOrderCreated(newOrder);
  //     history.push(`/edit-order/${newOrder.id}`);
  //   }
  // }, [newOrder]);

  // const filterColors = (inputValue: any) => {
  //   return (
  //     collaborators &&
  //     collaborators.filter((i: any) =>
  //       i.name.toLowerCase().includes(inputValue.toLowerCase())
  //     )
  //   );
  // };

  // const promiseOptions = (inputValue: any) =>
  //   new Promise((resolve) => {
  //     dispatch(getCollaborators(inputValue));
  //     resolve(
  //       collaborators
  //         .map((el: any) => {
  //           return {
  //             label: el.name,
  //             value: el.name,
  //           };
  //         })
  //         .filter((i: any) =>
  //           i.label.toLowerCase().includes(inputValue.toLowerCase())
  //         )
  //     );
  //     setData({
  //       ...data,
  //       collaborator: [
  //         ...data.collaborator,
  //         collaborators
  //           .map((el: any) => {
  //             return {
  //               label: el.name,
  //               value: el.name,
  //             };
  //           })
  //           .filter((i: any) =>
  //             i.label.toLowerCase().includes(inputValue.toLowerCase())
  //           ),
  //       ],
  //     });
  // setTimeout(() => {
  // resolve(filterColors(inputValue));
  // }, 1000);
  // });

  // useEffect(() => {
  //   filterColors(collaborators);
  // }, [collaborators]);

  const variants = {
    enter: { y: 1900 },
    center: { y: height },
    exit: { y: 1900 },
  };

  const handleChange = (e: any) => {
    setfolderData({ ...folderData, [e.target.name]: e.target.value });
  };
  const handleSeasonChange = (e: any) => {
    setfolderData({
      ...folderData,
      season: e.value,
    });
  };
  const handleYearChange = (e: any) => {
    setfolderData({
      ...folderData,
      year: e.value,
    });
  };
  const handleCollabChangeFolder = (e: any) => {
    setfolderData({
      ...folderData,
      collaborator: e && e.map((el: any) => el.value),
    });
  };
  const createNewFolder = () => {
    if (folderData.name === "") {
      var id = uuidv4();

      dispatch(setAlert("Please specify the folder name!", "danger", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
      return null;
    } else if (withRoot) {
      dispatch(
        createFolder({
          ...folderData,
          ...tags,
          parent_id: fodlerSelected.value,
          product_id: params.productId,
        })
      );
      dispatch(handleBottomDrawer());
      // dispatch(getAllFolders());
      dispatch(clearAllAlerts());
      var id = uuidv4();
      dispatch(setAlert("Folder added successfully", "success", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
    } else {
      dispatch(createFolder({ ...folderData, ...tags }));
      dispatch(handleBottomDrawer());
      // dispatch(getAllFolders());
      dispatch(clearAllAlerts());
      var id = uuidv4();
      dispatch(setAlert("Folder added successfully", "success", id));
      setTimeout(() => {
        dispatch(removeAlert(id));
      }, 5000);
    }

    setfodlerSelected("");
    setfolderData({
      name: "",
      description: "",
      collaborator: [],
      season:'',
      year:""
    });
    setTags([]);
  };

  const discard = () => {
    setfolderData({
      name: "",
      description: "",
      collaborator: [],
      season:'',
      year:""
    });
    setTags([]);
    dispatch(clearAllAlerts());
  };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [width]);
  useEffect(() => {
    setHeight(window.innerHeight);
  }, [window.innerHeight]);
  useEffect(() => {
    if (addArticle) {
      dispatch(getGenders());
    }
    if (withRoot) {
      dispatch(getAllFolders());
    }
  }, []);

  const customStyles = {
    //@ts-ignore
    option: (styles: any, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#00468c" : null,
        color: isSelected ? "white" : "black",
      };
    },
    control: (base: any) => ({
      ...base,
      border: 0,
      borderBottom: "1px solid #ccc",
      borderRadius: 0,
      padding: 0,
      // This line disable the blue border
      boxShadow: "none",
      "&:hover": {
        outline: "none",
      },
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      paddingLeft: 0,
      paddingBottom: 0,
    }),
    menu: (base: any) => ({
      ...base,
      marginTop: 0,
      color: "#00468c",
    }),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: 0,
      fontSize: 18,
    }),
    indicatorSeparator: (base: any) => ({
      ...base,
      display: "none",
    }),
    colors: (base: any) => ({
      ...base,
      primary: "#00468c",
      primary25: "#00468c",
    }),
  };

  const customStylesCreateModern = {
    control: (base: any, state: any) => ({
      ...base,
      background: "white",
      borderColor: state.isFocused ? "#00468c" : "#e2e8f0",
      borderRadius: "8px",
      padding: "2px",
      fontSize: "14px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#00468c",
      },
    }),
    placeholder: (base: any) => ({
      ...base,
      color: "#94a3b8",
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e2e8f0",
      zIndex: 100
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#00468c" : state.isFocused ? "#f1f5f9" : "white",
      color: state.isSelected ? "white" : "#1e293b",
      padding: "10px 12px",
      fontSize: "14px",
      cursor: "pointer"
    }),
  };

  const currentYear = new Date().getFullYear();

  const options_year = [
    { value: String(currentYear).slice(2), label: String(currentYear) },
    { value: String(currentYear + 1).slice(2), label: String(currentYear + 1) },
    { value: String(currentYear + 2).slice(2), label: String(currentYear + 2) },
    { value: String(currentYear + 3).slice(2), label: String(currentYear + 3) },
    { value: String(currentYear + 4).slice(2), label: String(currentYear + 4) },
  ];

  const options_season = [
    { value: 'ps', label: 'PS' },
    { value: 'ss', label: 'SS' },
    { value: 'pf', label: 'PF' },
    { value: 'fw', label: 'FW' }
  ];
  return (
    <BrowserRouter>
      <motion.div
        className={
          addOrderDrawer
            ? "add_folder_container add_order_container"
            : "add_folder_container"
        }
        style={{
          height: addOrderDrawer ? "100vh" : "calc(100vh - 109px)",
          justifyContent: addOrderDrawer ? "flex-start" : "space-between",
        }}
        transition={{ type: "tween" }}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
      >
        <div className="add_folder_top_redundant" style={{ display: "none" }}>
        </div>
        <div className="container">
          {addArticle ? (
            <AddArticleBottomDrawer
              handleChange={(x: any) => handleChange(x)}
              DropdownIndicator={DropdownIndicator}
              genders={allGenders}
              setfodlerSelected={setfodlerSelected}
            />
          ) : addOrderDrawer ? (
            <AddOrderBottomDrawer
              handleChangeOrder={handleChangeOrder}
              handleCollabChange={handleCollabChange}
              collaborators={collaborators}
              handlerType={handleType}
              handleChangeDeliveryDate={handleChangeDeliveryDate}
            />
          ) : (
            <div className="create_collection_form_modern" style={{ 
              padding: "24px", 
              borderRadius: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              maxWidth: "800px",
              margin: "0 auto",
              width: "100%"
            }}>
              <h3 style={{ fontSize: "18px", fontWeight: 700, color: "#1e293b", margin: 0 }}>New Collection</h3>
              
              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="e.g. Summer 2027"
                  value={folderData.name}
                  onChange={handleChange}
                  style={{ 
                    border: "1px solid #e2e8f0", 
                    borderRadius: "8px", 
                    width: "100%", 
                    outline: "none", 
                    fontSize: "14px", 
                    padding: "10px 14px",
                    background: "white",
                    transition: "border-color 0.2s"
                  }}
                />
              </div>

              <div style={{ display: "flex", gap: "16px" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                  <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Season</label>
                  <Select
                    placeholder="Select Season"
                    options={options_season}
                    value={options_season.find(o => o.value === folderData.season)}
                    onChange={handleSeasonChange}
                    styles={customStylesCreateModern}
                  />
                </div>
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                  <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Year</label>
                  <Select
                    placeholder="Select Year"
                    options={options_year}
                    value={options_year.find(o => o.value === folderData.year)}
                    onChange={handleYearChange}
                    styles={customStylesCreateModern}
                  />
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                <label style={{ fontSize: "13px", fontWeight: 500, color: "#475569" }}>Collaborators</label>
                <Select
                  isMulti
                  placeholder="Search names..."
                  options={collaborators?.map((c: any) => ({ label: c.name, value: c.id }))}
                  onChange={handleCollabChangeFolder}
                  styles={customStylesCreateModern}
                />
              </div>
            </div>
          )}
        </div>

        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "1fr 1fr", 
          gap: "12px", 
          marginTop: "8px", 
          maxWidth: "800px", 
          margin: "0 auto", 
          width: "100%", 
          paddingBottom: "24px" 
        }}>
          <button 
            onClick={() => {
              if (addFolder) {
                // dispatch(handleBottomDrawerAddFolder());
                setMode && setMode("add_to_collection");
              } else {
                setMode && setMode("add_to_collection");
                dispatch(clearAllAlerts());
                discard();
                dispatch(handleBottomDrawer());
              }
            }}
            style={{
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #e1e8f0",
              background: "white",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            Discard
          </button>
          <button 
            onClick={async () => {
              if (addOrderDrawer) {
                if (data.details && data.name) {
                  dispatch(addOrder(data, true));
                } else {
                  dispatch(addOrder(data, true));
                }
              }
              else {
                createNewFolder();
              }
            }}
            style={{
              padding: "12px",
              borderRadius: "10px",
              border: "none",
              background: "#00468c",
              color: "white",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer"
            }}
          >
            {createOrderLoading ? "Confirming..." : "Confirm"}
          </button>
        </div>
        {/* <div className="alerts_position">
          {alerts.alerts.map((el: any) => (
            <Alert alert={el} className="alert_missing_fodler_name" />
          ))}
        </div> */}
      </motion.div>
    </BrowserRouter>
  );
}
